export const LINKS = {
  email: "shantanusirjoshi@gmail.com",
  github: "https://github.com/dragonblade3k",
  linkedin: "https://www.linkedin.com/in/shantanusirjoshi",
  resume: "resume.pdf",
};

export const PROJECTS = [
  {
    slug: "f1-screenings",
    tag: "FLAGSHIP",
    title: "F1 Screenings Discovery Platform",
    description:
      "Finds live F1 screenings across the Mumbai metro from unstructured web listings. Every event passes a human review queue before going live. Malformed values turned up in 73% of extracted rows, fixed by constraining LLM decoding to a JSON schema instead of asking for JSON in the prompt.",
    tech: ["Next.js 14", "TypeScript", "Prisma", "Ollama — local LLM inference", "SerpAPI"],
    metrics: [
      ["verified events published", "11"],
      ["candidate listings", "70"],
      ["web sources", "20"],
      ["rows malformed, pre-fix", "73%"],
    ],
    url: "https://github.com/dragonblade3k/f1-screenings",
    flagship: true,
  },
  {
    slug: "content-pipeline",
    tag: "PIPELINE",
    title: "Content Pipeline",
    description:
      "Five-stage pipeline: live F1 API → LLM script → neural narration → captioned vertical video. Data source, model and voice each swap through one environment variable.",
    tech: ["Python", "Ollama", "Piper TTS", "ffmpeg"],
    metrics: [
      ["stages", "5"],
      ["tests", "28"],
    ],
    url: "https://github.com/dragonblade3k/content-pipeline",
  },
  {
    slug: "cancernet",
    tag: "ML / VISION",
    title: "CancerNet",
    description:
      "CNN for breast cancer histopathology classification, with Grad-CAM interpretability.",
    tech: ["TensorFlow", "Keras", "CUDA"],
    metrics: [
      ["accuracy", "86%"],
      ["ROC AUC", "0.91"],
      ["held-out patches", "99,906"],
    ],
    url: "https://github.com/dragonblade3k/Breast-Cancer-Classification",
  },
  {
    slug: "inventory",
    tag: "DESKTOP",
    title: "Inventory Management System",
    description:
      "Desktop stock management: inventory, suppliers, billing.",
    tech: ["Java", "SQL"],
    metrics: [
      ["modules", "inventory / suppliers / billing"],
    ],
    url: "https://github.com/dragonblade3k/Inventory-Management-System",
  },
];

export const EDUCATION = [
  {
    id: "EDU.01",
    degree: "MS, Computer Science",
    school: "University of Southern California",
    detail: "May 2027 · GPA 3.62",
  },
  {
    id: "EDU.02",
    degree: "BE, Computer Engineering",
    school: "University of Mumbai",
    detail: "2023 · GPA 8.82/10",
  },
];

export const STACK = ["Java", "Spring Boot", "Python", "TypeScript", "Next.js"];

export const HERO_BOARD = [
  ["1.5 YRS", "NSDL settlement services", "TCS"],
  ["11 / 70", "verified events / candidates", "F1 SCREENINGS"],
  ["99,906", "held-out patches classified", "CANCERNET"],
  ["0.91", "ROC AUC", "CANCERNET"],
];
